import { render, staticRenderFns } from "./accountGl.vue?vue&type=template&id=cbab929e&scoped=true&"
import script from "./accountGl.vue?vue&type=script&lang=js&"
export * from "./accountGl.vue?vue&type=script&lang=js&"
import style0 from "./accountGl.vue?vue&type=style&index=0&id=cbab929e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbab929e",
  null
  
)

export default component.exports